

export const aboutSecton = {
    mt: '64px',
    maxWidth: '90%',
}

export const aboutContainer = {
    flexDirection: 'column',
    alignItems: 'center',
    py: 5
}